export default __webpack_public_path__ + "static/media/output.5f7c430f.svg";